import { render, staticRenderFns } from "./CampaignDetailsHistory.vue?vue&type=template&id=0695f436&scoped=true"
import script from "./CampaignDetailsHistory.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695f436",
  null
  
)

export default component.exports